module.exports = __webpack_public_path__ + "static/media/smart-goals-large@2x.5314393e.png";